import React from 'react';
import { ZapIcon } from 'lucide-react';
type TopBarProps = {
  spotsLeft: number;
};
export function TopBar({
  spotsLeft
}: TopBarProps) {
  return <div className="sticky top-0 z-50 w-full bg-acid text-night" data-id="element-274" data-mp="231lwjv99m16p">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center" data-id="element-275" data-mp="1y4vdr062srhl">
        <ZapIcon className="hidden h-4 w-4 shrink-0 sm:block" aria-hidden="true" data-id="element-276" data-mp="1t60xo5zhth16" />
        <p className="text-[11px] font-bold uppercase tracking-[0.12em] sm:text-sm" data-id="element-277" data-mp="2qsrag4vnajed">
          Launch offer: the Total Academy System + 5 premium bonuses for $27
          <span className="ml-2 rounded-sm bg-night px-2 py-0.5 text-acid" data-id="element-278" data-mp="2lvr4rv2pjins">
            Only {spotsLeft} spots left
          </span>
        </p>
      </div>
    </div>;
}